import { render, staticRenderFns } from "./ownDetail.vue?vue&type=template&id=5bf02487&scoped=true"
import script from "./ownDetail.vue?vue&type=script&lang=js"
export * from "./ownDetail.vue?vue&type=script&lang=js"
import style0 from "./ownDetail.vue?vue&type=style&index=0&id=5bf02487&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf02487",
  null
  
)

export default component.exports